export default __webpack_public_path__ + "static/media/pakiet1.eeae3fc6.jpg";